import { Box, Typography, Link } from '@mui/material';

export default function RecaptchaLabel() {
  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', padding: '8px 24px' }}
    >
      <Typography
        variant="body2"
        sx={{ textAlign: 'center', color: (theme) => theme.palette.grey[500] }}
      >
        Este sitio está protegido por reCAPTCHA y Google.{' '}
        <Link
          href={'https://policies.google.com/privacy'}
          target="_blank"
          rel="noopener"
          underline="none"
        >
          Política de Privacidad
        </Link>{' '}
        y{' '}
        <Link
          href={'https://policies.google.com/terms'}
          target="_blank"
          rel="noopener"
          underline="none"
        >
          Términos de Servicio.
        </Link>
      </Typography>
    </Box>
  );
}
